import { render, staticRenderFns } from "./BecomingOrder.vue?vue&type=template&id=28e38d46"
import script from "./BecomingOrder.vue?vue&type=script&lang=js"
export * from "./BecomingOrder.vue?vue&type=script&lang=js"
import style0 from "./BecomingOrder.vue?vue&type=style&index=0&id=28e38d46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports